export default {
  CLIENT_ID: "1AcMuEizmbmBOhrf9XubbQoHNaLf8Sk1pOnVhCd8ifw",
  REDIRECT_URI: "https://www.soraremega.com/oauth/redirect",
  AFFILIATE_LINK: "https://sorare.pxf.io/SorareMega",
  TWITTER_URL: "https://x.com/SorareMega",
  ROLE: {
    ADMIN: "ROLE_ADMIN",
    USER: "ROLE_USER",
    BETA: "ROLE_BETA",
  },
  GAME_WEEK: {
    STATUS: {
      ENDED: "ENDED",
      WAITING: "WAITING",
      LIVE: "LIVE",
      OPEN: "OPEN",
    },
  },
  MEGA_LEAGUE: {
    CAP : 550,
    PLAYER_COUNT: 11,
    FORMATION: [
      '3-4-3',
      '3-3-4',
      '4-3-3',
      '4-4-2',
      '4-2-4',
      '4-5-1',
      '5-4-1',
      '5-3-2',
      '5-2-3',
      '3-5-2'
    ],
  },
  POSITION: {
    GOALKEEPER: "Goalkeeper",
    DEFENDER: "Defender",
    MIDFIELDER: "Midfielder",
    FORWARD: "Forward",
  },
  SNACKBAR: {
    COLOR: {
      SUCCESS: "success",
      ERROR: "error",
    },
    TEXT: {
      TEAM_CONFIRMED: "snackbar.team_successfully_confirmed",
      TEAM_CANCELED: "snackbar.team_canceled",
      MAX_TEAM: "snackbar.max_players_per_team"
    },
  },
};
